import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAllQuizList } from "../../api";
import { STRINGS } from "../../constants";
import { IMAGES } from "../../assets";
import QuizQuestion from "./QuizQuestion";
import IconTint from "react-icon-tint";
import { AuthContext } from "../../context";
import { AutoComplete, Input } from "antd";

const Quiz = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [quizItem, setQuizItem] = useState([]);
  const [questionList, setQuestionList] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [testStart, setTestStart] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [autoData, setAutoData] = useState();
  const [search, setSearch] = useState("");

  const { t } = useTranslation();
  const { activeLanguage, user } = useContext(AuthContext);
  useEffect(() => {
    quizList();
  }, [questionList]);

  async function quizList() {
    setIsLoading(true);
    const result = await getAllQuizList({ userId: user?.userInfo?._id });
    setIsLoading(false);
    const response = result?.data?.data ?? [];
    setFilteredData(response);
    const data = result?.data?.data?.map((ele) => {
      return {
        label: ele?.quizName,
        value: ele?.quizName,
      };
    });
    setAutoData(data);

    setQuizItem(response);
  }

  const onSelect = (value) => {
    setSearch(value);
  };
  const handleSearch = (value) => {
    setSearch(value);
  };

  useEffect(() => {
    const filtered = filteredData?.filter((item) => {
      return item?.quizName?.toLowerCase().startsWith(search.toLowerCase());
    });
    if (search === "") {
      return setQuizItem(filteredData);
    }

    setQuizItem(filtered);
  }, [search]);

  return (
    <div>
      <AutoComplete
        className="mb-2 w-1/2"
        onFocus={(e) => {}}
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        options={autoData}
        onSelect={onSelect}
        onSearch={handleSearch}
      >
        <Input
          size="lg"
          placeholder={t(STRINGS.search)}
          className="w-full"
        ></Input>
      </AutoComplete>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="px-3 py-2 bg-white rounded-md">
          <h2 className="text-lg font-medium">{t(STRINGS.quiz)}</h2>
          <div className="mt-4">
            {isLoading ? (
              <p>Loading...</p>
            ) : quizItem && quizItem.length > 0 ? (
              quizItem.map((item) => (
                <div
                  key={item?._id}
                  className="rounded-xl bg-[#FBFBFB] p-3 mt-2"
                >
                  <h2 className="text-base font-medium mb-2">
                    {item?.quizName}
                  </h2>
                  <p className="text-sm font-normal text-[#8A8A8A]">
                    {item?.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-medium mt-2 text-[#333333]">
                      {`${t(STRINGS?.no_of_quesions)} : ${
                        activeLanguage === "Marathi"
                          ? new Intl.NumberFormat("mr", {
                              maximumSignificantDigits: 2,
                            }).format(item?.questionCount)
                          : item?.questionCount
                      }`}
                    </p>
                    <button
                      onClick={() => {
                        setIsSubmit(false);
                        setQuestionList(item);
                        setTestStart(true);
                      }}
                      className="text-white text-sm bg-[#FE6B01] px-3 py-1 rounded-md flex items-center justify-between"
                    >
                      <span className="mr-2">{t(STRINGS.continue)}</span>
                      <IconTint
                        className="w-4 h-auto"
                        src={IMAGES?.nextLogo}
                        color="#fff"
                      />
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center mt-4">
                <p>{t(STRINGS.no_data)}</p>
              </div>
            )}
          </div>
        </div>
        {questionList && (
          <div className="px-3 py-2 bg-white rounded-md">
            <QuizQuestion
              quizListItem={questionList}
              setQuestionList={setQuestionList}
              setQuizItem={setQuizItem}
              isSubmit={isSubmit}
              setIsSubmit={setIsSubmit}
              testStart={testStart}
              setTestStart={setTestStart}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Quiz;
